import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-extended',
  templateUrl: './features-extended.component.html',
  styleUrls: ['./features-extended.component.scss']
})
export class FeaturesExtendedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
